import * as React from 'react';
export const IcPool = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20 13a6.209 6.209 0 00-4.71 2.29l-.29.29V6a1 1 0 012 0 1 1 0 002 0 3 3 0 00-6 0v2H7V6a1 1 0 012 0 1 1 0 002 0 3 3 0 00-6 0v7.09A6.197 6.197 0 004 13a1 1 0 00-1 1v6a1 1 0 001 1h16a1 1 0 001-1v-6a1 1 0 00-1-1zm-7 3.88a4.28 4.28 0 01-1 .12c-1.59 0-2.34-.75-3.29-1.71A11.31 11.31 0 007.23 14H13v2.88zM13 12H7v-2h6v2z'
      fill='currentColor'
    />
  </svg>
);
